import { callZpayFunction } from '../../callZpayFunction';

// 주문정보 갱신
export const updateOrder = (order_number: string) => {
  callZpayFunction('updateOrder')({ order_number });
};
